var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.82175H21C21.2652 3.82175 21.5196 3.9271 21.7071 4.11464C21.8946 4.30218 22 4.55653 22 4.82175V20.8217C22 21.087 21.8946 21.3413 21.7071 21.5289C21.5196 21.7164 21.2652 21.8217 21 21.8217H3C2.73478 21.8217 2.48043 21.7164 2.29289 21.5289C2.10536 21.3413 2 21.087 2 20.8217V4.82175C2 4.55653 2.10536 4.30218 2.29289 4.11464C2.48043 3.9271 2.73478 3.82175 3 3.82175H7V1.82175H9V3.82175H15V1.82175H17V3.82175ZM20 11.8217H4V19.8217H20V11.8217ZM15 5.82175H9V7.82175H7V5.82175H4V9.82175H20V5.82175H17V7.82175H15V5.82175ZM6 13.8217H8V15.8217H6V13.8217ZM11 13.8217H13V15.8217H11V13.8217ZM16 13.8217H18V15.8217H16V13.8217Z",
    fill: "#0A4468"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar1);
export default __webpack_public_path__ + "static/media/calendar_1.43a1aecebbe3fa54aa56e008d49f2cb5.svg";
export { ForwardRef as ReactComponent };